import React, { useRef } from "react";
import "./TestimonialsSection.css";
import img1 from "../assets/testimonial_1.png";
import img2 from "../assets/testimonial_2.png";
import img3 from "../assets/testimonial_3.png";
import playIcon from "../assets/icons/arrow_circle.svg";
import navArrowLeft from "../assets/icons/nav_arrow_left.svg";
import navArrowRight from "../assets/icons/nav_arrow_right.svg";
import sectionLabel from "../assets/icons/section_label.svg";

const carouselImages = [
  { src: img1, alt: "Client result 1" },
  { src: img2, alt: "Client result 2" },
  { src: img3, alt: "Client result 3" },
  { src: img1, alt: "Client result 4" },
  { src: img2, alt: "Client result 5" },
];

const TestimonialsSection = () => {
  const scrollRef = useRef(null);

  const scroll = (dir) => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: dir * 504, behavior: "smooth" });
    }
  };

  return (
    <section className="testimonials-section">
      <div className="testimonials-container">
        <div className="testimonials-header">
          <div className="testimonials-section-label">
            <img src={sectionLabel} alt="" width="192" height="32" />
          </div>
          <h2 className="testimonials-title">
            Real clients. Personalized results.
          </h2>
          <p className="testimonials-subtitle">
            From sleep struggles and burnout to hormone imbalance and chronic
            digestive issues, Hua Shen formulas are designed to address the root
            pattern behind symptoms — not just temporary relief.
          </p>
        </div>

        <div className="testimonials-carousel-wrap">
          <div className="testimonials-carousel-track" ref={scrollRef}>
            {carouselImages.map((img, i) => (
              <div className="testimonials-carousel-card" key={i}>
                <img src={img.src} alt={img.alt} />
                <img src={playIcon} alt="" className="testimonials-play-icon" />
              </div>
            ))}
          </div>
          <div className="testimonials-overlay testimonials-overlay--left" />
          <div className="testimonials-overlay testimonials-overlay--right" />
          <button
            className="testimonials-arrow testimonials-arrow--prev"
            onClick={() => scroll(-1)}
            aria-label="Previous"
          >
            <img src={navArrowLeft} alt="" className="testimonials-arrow-img" />
          </button>
          <button
            className="testimonials-arrow testimonials-arrow--next"
            onClick={() => scroll(1)}
            aria-label="Next"
          >
            <img
              src={navArrowRight}
              alt=""
              className="testimonials-arrow-img"
            />
          </button>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
